import { IController } from 'angular';
import * as _ from 'lodash';
import nvSdcModule from '../../../../nv.sdcModule.module';

export class GridColumnGroupCtrl implements IController {
  static $inject = ['$scope', '$timeout', 'SorterColumn', 'SDCStore'];

  // Bindings
  private isColGroupShown;
  private selectedColsInGroup;
  private columnKeys;
  private groupName;
  private groupCols;
  private group;
  private allSelectedCols;

  constructor(private $scope, private $timeout, private SorterColumn, private SDCStore) {}

  $onInit() {
    this.isColGroupShown = false;

    this.selectedColsInGroup = [];

    this.columnKeys = this.SDCStore.getColumnKeys();

    this.groupName = _.startCase(this.group.groupName);

    this.groupCols = this.group.groupColumns;

    // set selected count on load
    _.each(this.groupCols, v => {
      if (_.includes(this.SDCStore.getColumnKeys(), v)) this.selectedColsInGroup.push(v);
    });
  }

  // Methods
  getColHumanName = machineName => {
    const sorterCol = this.SorterColumn.getByColumnKey(machineName);

    return sorterCol ? sorterCol.humanName : '(unknown)';
  };
  // checks the box if the related column has been passed to allSelectedCols
  // OR is one that was loaded into sorter initially.
  exists = item => {
    return this._checkForInclusion(item);
  };

  // displays hyphen in the box if the related column has been passed to allSelectedCols
  // OR is one that was loaded into sorter initially.
  isIndeterminate = () => {
    // return _.any(this.groupCols, function(gV) {
    //   return this._checkForInclusion(gV);
    // });

    if (!_.isUndefined(this.allSelectedCols)) {
      return this.allSelectedCols.length !== 0 && this.allSelectedCols.length !== this.groupCols.length;
    }
  };

  // return true for the entire group (which checks the Select All box) if each groupValue
  // is found in either allSelectedCols already or each groupValue was in the initial column set
  isChecked = () => {
    return _.every(this.groupCols, gV => {
      return this._checkForInclusion(gV);
    });
  };

  toggle = col => {
    if (this.exists(col)) {
      this._pullOut(col);
    } else {
      this._pushIn(col);
    }
  };

  toggleAll = () => {
    let unselectedCols = _.difference(this.groupCols, this.allSelectedCols, this.SDCStore.getColumnKeys());

    if (unselectedCols.length === 0) {
      _.each(this.groupCols, col => {
        this._pullOut(col);
      });
    } else {
      _.each(unselectedCols, col => {
        this._pushIn(col);
      });
    }
  };

  _pullOut = col => {
    _.pull(this.selectedColsInGroup, col);
    _.pull(this.allSelectedCols, col);
    _.pull(this.SDCStore.getColumnKeys(), col);

    if (this.selectedColsInGroup.length === 0) this.isColGroupShown = false;
  };

  _pushIn = col => {
    let _sorterColumn = _.union(this.columnKeys, ['studentId', 'studentName']);
    this.selectedColsInGroup.push(col);
    this.allSelectedCols.unshift(col);
    _sorterColumn.unshift(col);
  };

  // returns true if col is found either in all selected columns array or in the initial sorter columns array
  _checkForInclusion = col => {
    let _sorterColumn = _.union(this.columnKeys, ['studentId', 'studentName']);
    return _.includes(this.allSelectedCols, col) || _.includes(_sorterColumn, col);
  };
}

angular.module(nvSdcModule).controller('gridColumnGroupCtrl', GridColumnGroupCtrl);
